var viewer_caption_rtlignore_default = {
  "fontElementMap": "nD8y2",
  "imageCaption": "_68zvF"
};
export {
  viewer_caption_rtlignore_default as default
};
//# sourceMappingURL=viewer-caption.rtlignore-scss.js.map
